import { render, staticRenderFns } from "./ReminderWidget.vue?vue&type=template&id=fd09a7e4&"
import script from "./ReminderWidget.vue?vue&type=script&lang=js&"
export * from "./ReminderWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports